module.exports = __webpack_public_path__ + "static/img/5.aacbd64.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/zh/5.png
// module id = rF9K
// module chunks = 0